import { render, staticRenderFns } from "./CadastrarEscalas.vue?vue&type=template&id=7ac668b2"
import script from "./CadastrarEscalas.vue?vue&type=script&lang=js"
export * from "./CadastrarEscalas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports